// Which access locks apply to a user (Superadmin_Manual_Approval_FE.md §0).
// Decide from company type / registration source / role only; never from flow.blocking, which lists every lock for everyone.

export interface IAccessLocks {
	/** E-mail must be confirmed before the user can log in. */
	email: boolean
	/** Our KYC verdict must be approved before the cabinet opens. */
	kyc: boolean
}

interface ILockSubject {
	companyType?: unknown
	companyRole?: unknown
	/** Unknown in the user list rows: only `system/user/overview` returns `company.registration_source`. */
	registrationSource?: unknown
}

export const accessLocks = ({ companyType, companyRole, registrationSource }: ILockSubject): IAccessLocks => {
	// Companies created in the backoffice are not held by either lock.
	if (registrationSource === "backoffice") return { email: false, kyc: false }
	const isPrivate = companyType === "private"
	return {
		email: isPrivate || registrationSource === "signup",
		kyc: isPrivate || (companyType === "company" && companyRole === "admin")
	}
}

/** Approval does not unblock a disabled user; that needs system/users/unblock. */
export const isBlocked = (userStatus?: unknown, companyStatus?: unknown) =>
	[userStatus, companyStatus].some((value) => typeof value === "string" && value !== "" && value !== "active")
